<template>
  <div id="map-container" style="height: 600px;"></div> <!-- Map container -->
</template>
<script>
// @ is an alias to /src
// eslint-disable-next-line no-unused-vars
import { ref, onMounted, getCurrentInstance } from 'vue';
import Service from '@/services/ask-pratiche/pratiche-wizard'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

export default {
  setup() {
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const service = new Service(self.$eventBus)
    const map = ref(null);
    const locations = ref([]);
    
    const getDetailPoints = async () => {
      await service.getDetailPoints()
        .then((res) => {
          Object.keys(res.items).forEach(key => {
            res.items[key].lat = Number(res.items[key].lat)
            res.items[key].lng = Number(res.items[key].lng)
          })
          locations.value = res.items
        })
    }
    const initMap = async () => {
      await getDetailPoints()
        .then((res) => {

          map.value = L.map('map-container').setView([41.9028, 12.4964], 6); // Set initial map view

          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© OpenStreetMap contributors'
          }).addTo(map.value);

          // Create a bounds group from all location markers
          const markers = locations.value.map(location => {
            let color
            if (location.is_point_diretto) {
              color = 'green'
            } else if(location.is_point){
              color = 'blue'
            } else{
              color = 'senape'
            }
            const customIcon = L.icon({
              iconUrl: `/images/marker-icon-agf-${color}_72.png`,
              iconSize: [25, 41],
              iconAnchor: [50, 41],
              popupAnchor: [1, -34],
              shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
              shadowSize: [41, 41]
            });
            const popupContent = `
              <div style="text-align: center;">
                <strong>${location.name}</strong><br>
                <span style="font-size: smaller;">${location.address || ''}</span>
              </div>
            `;
            return L.marker([location.lat, location.lng], { icon: customIcon })
              .addTo(map.value)
              .bindPopup(popupContent);
          });

          const group = L.featureGroup(markers);
          map.value.fitBounds(group.getBounds(), { padding: [80, 80] });
        })
    };

    onMounted(() => {
      Promise.all([
        initMap()
      ])
    });

    return {
      locations,
      map
    };
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Host+Grotesk:ital,wght@0,300..800;1,300..800&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Host+Grotesk:ital,wght@0,300..800;1,300..800&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');

/* .app {
  padding-top: 60px;
} */

body {
  margin: 0;
  font-family: 'Host Grotesk', sans-serif;
  background-color: #000;
}


.flex-container {
  display: flex;
  height: 50vh;
}

/* NAVBAR */
.nav_fnp {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 10px 20px;
  background-color: transparent !important;
}

.nav_gdf,
.nav_gdf_cec {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: #434343 !important;
  height: 150px;

}

.bg-black {
  background-color: #217b01d4 !important;
}

.bg-black-gdf,
.bg-black-cec {
  background-color: #707070 !important;
}

.left-logo img {
  width: 20% !important;
  margin-top: 20px;
  margin-left: 0;
}

.right-logo img {
  width: 39% !important;
  margin-top: 20px;
  margin-left: 60%;
}

.right-logo-gdf img,
.right-logo-cec img {
  width: 15% !important;
  margin-top: 20px;
}

.main-content {
  padding-top: 150px;
}

/* FINE NAVBAR */


.offer-title {
  font-size: 1.90rem !important;
  color: #ffffff !important;
  text-align: start;
  margin-bottom: 20px;
  margin-top: 40px;
  margin-left: 20px;
}

.offerta-variabile {
  display: flex;
  align-items: center;
  margin-top: 80px;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}

.nostra-offerta_fnp {
  background-color: white;
  padding: 20px;
}

.offerta-variabile-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.variabile {
  display: inline;
  font-size: 2.5rem;
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  margin: 20px auto;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.variabile:hover {
  transform: scale(1.05);
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.4);
}

.title-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 20px;
}

.left-title-penseri,
.right-title-pensieri {
  font-size: 2rem;
  color: #0f0d0d;
  margin: 0;
}

.title-container h1 {
  margin-top: 10px;
}

.center-title {
  text-align: center;
  font-size: 2rem;
  color: white;
  background: #006344;
  padding: 10px;
  margin: 20px auto;
  border-radius: 8px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
  width: 60%;
  max-width: 800px;

}

.large-price-prezzo {
  display: inline-block;
  font-size: 2.25rem;
  color: white;
  padding: 0.5rem;
  border-radius: 8px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
  margin: 20px 0 10px 80px;
  text-align: left !important;
  background: #93c04a;
}

.logo {
  flex: 1;
  text-align: center;
}

.logo-image-offerta {
  display: block;
  margin: 0 auto;
  width: 10%;
  height: auto;
  margin-top: 30px;
}

::v-deep .p-tabview-nav {
  justify-content: center;
  font-size: 2.5rem;
  padding: 10px 20px;
  margin-top: 20px;
  border: none !important;
}

::v-deep .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: #000000 !important;
  color: #93c04a !important;
  outline: none !important;
}

::v-deep .p-tabview-nav-link {
  outline: 0 none;
  outline-offset: 0;
  border-color: transparent;
  color: #455766;
  padding: 1rem;
  font-weight: 600;
  border-top-right-radius: 9px;
  border-top-left-radius: 9px;
  transition: box-shadow 0.2s;
  margin: 0 0 -2px 0;
}

.fade-in {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.5s ease-out, transform 0.5s ease-out;
}

.fade-in.active {
  opacity: 1;
  transform: translateY(0);
}

.title {
  margin-bottom: 30px;
  text-align: center;
}

.separator {
  background-color: #93c04a;
  height: 2px;
  width: 70%;
  margin: 20px auto;
}

/*NUOVE MODIFICHE */

.convenzioni_fnp {
  display: none;
}

.offer-details {
  padding: 85px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
}

.offer-details_fnp {
  background-color: #ffffff;
}

.offer-item {
  width: 100%;
  max-width: 1200px;
  text-align: center;
  margin-bottom: 15px;
}

.custom-button {
  margin-top: 10px;
  font-size: 1rem;
  padding: 15px 40px;
  transition: background-color 0.3s ease, transform 0.3s ease;
  background-color: #eeff00;
  color: black;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.custom-button:hover {
  background-color: #c5e700;
  transform: scale(1.1);
}

.button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 0;
  padding: 20px;
  text-align: center;
}

.offer-title {
  font-size: 3rem;
  color: rgb(0, 0, 0);
  font-family: 'Host Grotesk', sans-serif;
  margin-bottom: 10px;
}

.left-div,
.right-div {
  flex: 1;
  background-color: #000;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  margin: -11px 3px;
}

.text-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #000000;
  color: white;
  font-family: "Raleway", sans-serif;
}

.small-title {
  font-size: 1.75rem;
  font-family: 'Host Grotesk', sans-serif;
}

.large-price {
  font-size: 3.75rem;
  font-family: 'Host Grotesk', sans-serif;
}

.custom-background {
  background: #75bf15;
  width: 63%;
  font-size: 3rem;
  color: white;
  padding: 0.70rem;
  border-radius: 8px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
  margin-bottom: 10px;
}

.content {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.rounded-container {
  display: flex;
  height: 70vh;
  padding: 50px 80px;
  gap: 20px;
}

.offerte {
  max-width: 100%;
  /* Ensures the image never exceeds its parent width */
  height: 620px;
  /* Allows the height to adjust and maintain aspect ratio */
  display: block;
  /* Remove inline spacing */
}

.gradient-hover {
  background: linear-gradient(49deg, #478509, #54a360);
  transition: background 0.3s ease;
  border-radius: 8px;
  flex: 1;
  padding: 20px;
}

.gradient-hover:hover {
  background: linear-gradient(135deg, #2e421a, #99da93);
}

.left-section {
  flex: 1;
  padding: 50px;
  padding-right: 20px;
}

.comprehension-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
  background-color: #ffffff;
}

.comprehension-content {
  display: flex;
  width: 100%;
  margin-top: 50px;
  margin-left: 50px;
}

.comprehension-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-right: 10px;
}

.eligibility-content {
  display: flex;
  justify-content: center !important;
  width: 100%;
  max-width: 1200px;
  align-items: flex-start;
}

.comprehension-title {
  font-family: 'Host Grotesk', sans-serif;
  font-size: 2.5rem;
  color: #ffffff;
  margin-bottom: 20px;
  /* text-align: left !important; */
}

.right-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 41%;
}

.responsive-image {
  max-width: 100%;
  height: auto;
}

.responsive-image-bolletta {
  width: 70%;
  max-width: 100%;
}

.responsive-image-bolletta-eligibility {
  width: 70%;
  max-width: 100%;
}

.prezzo {
  flex: 1;
  border-radius: 15px;
  padding: 60px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  color: #ffffff;
  margin: 0 10px;
}

.font-normal {
  font-size: 1rem;
  text-align: left;
}

.bolletta-testi {
  font-size: 1.5rem !important;
  color: #4c4c4c !important;
  font-weight: 700;
}

.centered-paragraph {
  color: #4c4c4c !important;
  font-weight: 700;
  text-align: center;
}

.details-list {
  list-style-type: disc;
  padding-left: 20px;
  color: #4c4c4c;
  text-align: left;
  font-size: 1.5rem;
  margin: 0;
  font-family: 'Host Grotesk', sans-serif;
}

.price-container {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background-color: #ffffff;
}

.footer_gdf,
.footer_cec {
  background-color: #434343 !important;
  color: #fff;

}

.footer_fnp {
  background-color: #45912c !important;
  color: #fff;

}

.footer-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.row {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.single-cta {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: 15px;
  transition: transform 0.3s ease;
  font-family: 'Host Grotesk', sans-serif;
  font-size: 20px;
}

.single-cta i {
  font-size: 25px;
  margin-right: 10px;
  color: #93c04a;
  transition: color 0.3s ease;
}

.social-media-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
}

.social-media-list li {
  margin: 0 10px;
}

.single-cta:hover i {
  color: #ffffff;
  transform: translateY(-5px);
}

/* MAP */
.legend {
  font-size: 14px;
  /* Adjust font size as necessary */
}

.dot {
  width: 12px;
  /* Diameter of the dot */
  height: 12px;
  /* Diameter of the dot */
  border-radius: 50%;
  /* Making it circular */
}

.chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 40px;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
  margin: 30px 0;
}

.chart-header {
  margin-bottom: 20px;
}

.chart-title {
  font-size: 2rem;
  color: #000;
  font-weight: bold;
  font-family: 'Host Grotesk', sans-serif;
  text-align: center;
}

#map-container {
  height: 570px !important;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

@media (max-width: 768px) {
  body {
    overflow-x: hidden;
  }


  .navbar {
    display: flex;
    align-items: center;
  }

  .nav_gdf,
  .nav_gdf_cec {
    background-color: #434343 !important;
    height: 80px;
  }

  .right-logo-gdf img,
  .right-logo-cec img {
    width: 30% !important;
  }

  .left-logo img {
    width: 60% !important;
  }

  .main-content {
    padding-top: 30px;
  }

  .title {
    display: none;
  }

  .logo_fnp {
    display: none;
  }

  .logo_gdf {
    display: block;
  }

  .logo-image-offerta {
    display: block;
    margin: 0 auto;
    width: 60%;
    height: auto;
    margin-top: 30px;
  }

  .offer-details {
    flex-direction: column !important;
    align-items: center;
    width: 100%;
    padding: 94px 10px;
    margin-top: 20%;
  }

  .center-title {
    width: 88%;
  }

  .right-div {
    width: 100%;
    margin: 10px 0;
    text-align: center;
  }

  .large-price {
    font-size: 1.5rem;
  }

  .small-title {
    font-size: 1.5rem !important;
  }

  .center-title {
    font-size: 1.5rem;
  }

  .offerte {
    margin-top: 12%;
    margin-bottom: 12%;
    width: 60%;
  }

  .offer-title {
    font-size: 3rem !important;
    margin-bottom: 85px;
  }

  .rounded-container {
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 20px;
  }

  .left-div,
  .right-div {
    width: 100%;
    margin-bottom: 10px;
    text-align: center;
    padding: 10px;
    background-color: rgba(255, 255, 255, 0.1);
  }

  .price-container {
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }

  .font-normal {
    font-size: 1rem;
    text-align: left;
  }

  .prezzo {
    flex: none;
    padding: 0;
    text-align: center;
    width: 100%;
  }

  .large-price {
    font-size: 1.5rem;
    background: #93c04a;
    color: white;
    padding: 0.5rem;
    border-radius: 8px;
    box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.2);
    margin: 10px 0;
    text-align: center;
  }

  .custom-background {
    width: 100%;
    font-size: 2rem;
    padding: 0.5rem;
    margin-top: 20px;
  }

  .image-container {
    flex: none;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
  }

  .image-container img {
    max-width: 70%;
    height: auto;
  }

  .details-list {
    padding-left: 0;
    list-style-position: inside;
    margin: 0;
    font-size: 1rem;
  }

  .details-list li {
    text-align: left;
    line-height: 1.5;
    margin: 5px 0;
  }

  .content {
    text-align: center;
  }

  .comprehension-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }

  .comprehension-container-bolletta {
    margin-bottom: 60px;
  }

  .left-section,
  .right-section {
    flex: 1;
    padding: 10px;
    max-width: 400px;
  }

  .left-section img,
  .right-section img {
    height: 302px;
    max-width: none;
    margin-bottom: 10px;
    padding: 10px;
  }

  .responsive-image-bolletta-eligibility {
    height: 168px;
    width: 537px;
    margin-bottom: 10px;
  }

  .comprehension-content {
    max-width: 100% !important;
    margin: 20px auto !important;
    padding: 20px !important;
    margin-top: 20px !important;
    display: flex;
    flex-direction: column !important;
    align-items: center;
  }

  .comprehension-text {
    font-size: 1.8rem;
    margin-bottom: 10px;
  }

  .comprehension-title {
    font-size: 1.8rem;
    margin-bottom: 10px;
  }

  .separator {
    width: 97%;
    margin: 10px auto;
  }

  .bolletta-testi {
    font-size: 1.25rem !important;
    color: #9f9f9f;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 0 10px;
  }

  .centered-paragraph {
    font-size: 1rem !important;
    color: #9f9f9f;
    margin-top: 10px;
    margin-bottom: 10px;
    padding: 0 10px;
    text-align: center;
  }

  .eligibility-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 1200px;
  }

  .responsive-image {
    height: auto !important;
    max-width: 100% !important;
  }

  .offer-details {
    flex-direction: column !important;
    align-items: center;
    width: 100%;
    padding: 0 10px;
    border-radius: 0;
  }


  /* FOOTER */
  .footer-section {
    background-color: #232323;
    color: #fff;
    padding: 20px 0;
    text-align: center;
  }

  .footer-cta {
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
  }

  .row {
    flex-direction: column;
    align-items: center;
    margin: 0;
  }

  .col-xl-4,
  .col-md-4 {
    width: 100%;
    margin-bottom: 20px;
    margin-right: 0;
  }

  .single-cta {
    margin: 0 10px;
  }

  .cta-text h4 {
    font-size: 1rem;
    margin-bottom: 5px;
  }

  .cta-text span,
  .cta-text ul {
    font-size: 0.875rem;
  }

  .social-media-list {
    list-style-type: none;
    padding: 0;
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }

  .social-media-list li {
    margin: 0 5px;
  }

  .footer-logo img {
    width: 50%;
    margin-top: 20px;
  }
}
</style>